'use client';

import { useEffect, useState } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import Select from '@/components/elements/select/select';
import { languageDefaultCode, LanguageItem, languages } from '@/i18n/languages';
import { WithLang } from '@/types/general';
import { localeRegExp, storageKeys } from '@/utils/constants';
import { Cookies } from '@/utils/cookies';
import { createTestId } from '@/utils/string-utils';

export default function SwitcherLanguage(props: WithLang<{ icon?: string }>) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const [selectedLanguage, setSelectedLanguage] = useState<LanguageItem | undefined>();

    useEffect(() => {
        setSelectedLanguage(
            languages.find((language) => language.code === props.lang) ||
                languages.find((language) => language.code === Cookies.get(storageKeys.prefLanguage)) ||
                languages.find((language) => language.code === languageDefaultCode),
        );
    }, [props.lang]);

    const changeLanguage = (newLanguage: LanguageItem) => {
        Cookies.setLocale(storageKeys.prefLanguage, newLanguage.code);

        if (!pathname.match(localeRegExp.exp)?.[2]) return;
        const newPathname = pathname.replace(localeRegExp.exp, localeRegExp.language(newLanguage.code));
        const queryParams = searchParams ? `?${searchParams}` : ``;
        router.push(newPathname + queryParams);
        router.refresh();
    };

    return (
        selectedLanguage && (
            <Select
                testId={createTestId({ name: 'select-language' })}
                icon="language-icon"
                options={languages}
                defaultValue={selectedLanguage}
                onClick={(option) => changeLanguage(option)}
            />
        )
    );
}
